import React, { useEffect, useRef } from "react";
import { CELEBRATION_COLORS } from "../../../constants/theme";

const COLS = CELEBRATION_COLORS;

/**
 * Burst of confetti over its parent. Render inside a positioned container
 * (e.g. <div className="modal" style={{position:"relative"}}><Confetti/>...).
 * Re-fires whenever `fire` changes.
 */
export default function Confetti({ fire = true }) {
  const ref = useRef(null);
  useEffect(() => {
    const wrap = ref.current;
    if (!wrap || !fire) return undefined;
    const frames = [];
    for (let i = 0; i < 26; i++) {
      const p = document.createElement("i");
      const a = Math.random() * Math.PI * 2;
      const d = 60 + Math.random() * 110;
      p.style.cssText = `position:absolute;left:50%;top:42%;width:7px;height:11px;border-radius:2px;background:${COLS[i % 6]};transition:transform .9s cubic-bezier(.15,.7,.3,1),opacity .9s;`;
      wrap.appendChild(p);
      frames.push(requestAnimationFrame(() => frames.push(requestAnimationFrame(() => {
        p.style.transform = `translate(${Math.cos(a) * d}px,${Math.sin(a) * d}px) rotate(${Math.random() * 360}deg)`;
        p.style.opacity = 0;
      }))));
    }
    const done = setTimeout(() => { wrap.textContent = ""; }, 1000);
    return () => { clearTimeout(done); frames.forEach(cancelAnimationFrame); wrap.textContent = ""; };
  }, [fire]);
  return <div ref={ref} aria-hidden="true" style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden", zIndex: 3 }} />;
}
